import { render, staticRenderFns } from "./email_modal.vue?vue&type=template&id=0dd4fc5c"
import script from "./email_modal.vue?vue&type=script&lang=js"
export * from "./email_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd4fc5c')) {
      api.createRecord('0dd4fc5c', component.options)
    } else {
      api.reload('0dd4fc5c', component.options)
    }
    module.hot.accept("./email_modal.vue?vue&type=template&id=0dd4fc5c", function () {
      api.rerender('0dd4fc5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/site_settings/email_modal.vue"
export default component.exports